import L from "leaflet";
import "leaflet/dist/leaflet.css";
import iconoMarcador from "leaflet/dist/images/marker-icon.png";
import iconoMarcador2x from "leaflet/dist/images/marker-icon-2x.png";
import sombraMarcador from "leaflet/dist/images/marker-shadow.png";

// Con webpack Leaflet no encuentra los íconos del marcador por defecto
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconUrl: iconoMarcador,
    iconRetinaUrl: iconoMarcador2x,
    shadowUrl: sombraMarcador,
});

// Centro de México
const CENTRO_DEFAULT = [23.6345, -102.5528];
const ZOOM_DEFAULT = 5;
const ZOOM_CALLE = 17;

const CAPA_OSM = {
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    maxZoom: 19,
};

// GeoJSON usa [lng, lat] y Leaflet [lat, lng]; Leaflet cierra el anillo solo
const areaALatLngs = (area) => {
    const anillo = area?.coordinates?.[0];
    if (!Array.isArray(anillo) || anillo.length < 3) return null;
    const puntos = anillo.map(([lng, lat]) => [lat, lng]);
    const [primero] = puntos;
    const ultimo = puntos[puntos.length - 1];
    if (primero[0] === ultimo[0] && primero[1] === ultimo[1]) puntos.pop();
    return puntos;
};

const latLngsAArea = (latLngs) => {
    const anillo = latLngs.map((punto) => [punto.lng, punto.lat]);
    anillo.push([...anillo[0]]);
    return { type: "Polygon", coordinates: [anillo] };
};

export {
    CENTRO_DEFAULT,
    ZOOM_DEFAULT,
    ZOOM_CALLE,
    CAPA_OSM,
    areaALatLngs,
    latLngsAArea,
};
